const VALUE_EXCEPTIONS = {
  en: 'English',
  es: 'Spanish',
  m: 'Male',
  f: 'Female',
  epipen: 'EpiPen',
};

export function toTitleCase(str) {
  if (!str) return str;
  return String(str)
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

export function formatValue(val) {
  if (val === null || val === undefined || val === '') return '—';
  if (typeof val === 'boolean') return val ? 'Yes' : 'No';
  const str = String(val);
  const lower = str.toLowerCase();
  if (VALUE_EXCEPTIONS[lower] !== undefined) return VALUE_EXCEPTIONS[lower];
  if (str.includes('@')) return str;
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str;
  if (/^[A-Za-z]{2}$/.test(str)) return str.toUpperCase();
  if (lower === 'yes' || lower === 'true') return 'Yes';
  if (lower === 'no' || lower === 'false') return 'No';
  return toTitleCase(str);
}
